import styled from "styled-components";
import RadioCheckmark from "./RadioCheckmark";
import RadioDot from "./RadioDot";

export default styled.input`
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;

  border: 1px solid #09100f;
  // background-color: blue;

  &:hover ~ ${RadioCheckmark} {
    border: none;
    // background-color: blue;
    background: linear-gradient(90deg, #ff7369 0%, #d83848 111.81%);
    color: #f9f8f5;
  }

  &:hover ~ ${RadioDot} {
    border: none;
    // background: linear-gradient(90deg, #ff7369 0%, #d83848 111.81%);
    background: #f9f8f5;
    color: #f9f8f5;
  }

  &:checked ~ ${RadioCheckmark} {
    border: 1px solid #09100f;
    background-color: #09100f;
    color: #f9f8f5;
  }

  &:checked ~ ${RadioDot} {
    border: 1px solid #f9f8f5;
    background: #f9f8f5;
    color: #f9f8f5;
  }
`;
